export default __webpack_public_path__ + "static/media/bg.26826478.png";